import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./UseAuth";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ width: "100%", padding: "20px" }}>
        <div className="skeleton" style={{ height: "50px" }}></div>
        <div className="skeleton" style={{ marginTop: "10px", height: "50px" }}></div>
        <div className="skeleton" style={{ marginTop: "10px", height: "50px" }}></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
